"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

var _sizes = require("HubStyleTokens/sizes");

var _UIFlex = _interopRequireDefault(require("./UIFlex"));

var FlexContainer = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "UIButtonWrapper__FlexContainer",
  componentId: "j5mkx1-0"
})(["margin-left:-", ";margin-top:-", ";max-width:none;width:auto;@media only screen and (max-width:", "){flex-grow:1;}&&& > *{margin-left:", ";margin-top:", ";}"], function (props) {
  return (0, _Styles.toPx)(props.horizontalGap);
}, function (props) {
  return (0, _Styles.toPx)(props.verticalGap);
}, _sizes.GRID_BREAKPOINT_SMALL, function (props) {
  return (0, _Styles.toPx)(props.horizontalGap);
}, function (props) {
  return (0, _Styles.toPx)(props.verticalGap);
});

var UIButtonWrapper = function UIButtonWrapper(props) {
  var alignItems = props.alignItems,
      children = props.children,
      horizontalGap = props.horizontalGap,
      justify = props.justify,
      verticalGap = props.verticalGap,
      rest = (0, _objectWithoutProperties2.default)(props, ["alignItems", "children", "horizontalGap", "justify", "verticalGap"]);
  return _react.default.createElement("div", rest, _react.default.createElement(FlexContainer, {
    align: alignItems,
    horizontalGap: horizontalGap,
    justify: justify,
    verticalGap: verticalGap,
    wrap: "wrap"
  }, children));
};

UIButtonWrapper.propTypes = {
  alignItems: _UIFlex.default.propTypes.align,
  children: _propTypes.default.node,
  justify: _UIFlex.default.propTypes.justify,
  horizontalGap: _propTypes.default.number,
  verticalGap: _propTypes.default.number
};
UIButtonWrapper.defaultProps = {
  alignItems: 'center',
  horizontalGap: parseInt(_sizes.BASE_SPACING_X, 10),
  verticalGap: parseInt(_sizes.BASE_SPACING_Y, 10)
};
UIButtonWrapper.displayName = 'UIButtonWrapper';
var _default = UIButtonWrapper;
exports.default = _default;
module.exports = exports.default;